import { useMemo } from "react";
import { useAppSelector } from "@store";
import { SortDirections } from "app/ApiClient";
import { maxStringBy } from "utils/arrayHelper";
import { sortString } from "utils/sortHelper";

export const useNormalizedVersions = (sorting: SortDirections) => {
  const { versions } = useAppSelector((state) => state.projectSelector);

  const sortedVersions = useMemo(
    () => [...versions].sort((a, b) => sortString(a.versionId, b.versionId, sorting)),
    [sorting, versions],
  );
  const maxVersionId = useMemo(() => maxStringBy(versions, (version) => version.versionId), [versions]);
  return {
    sortedVersions,
    maxVersionId,
  };
};
